import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';

export async function isPoolOwner(
  client: PublicClient,
  {
    poolAddress,
    accountAddress,
  }: { poolAddress: Address; accountAddress: Address },
) {
  const poolContract = getDelegateStakingPoolContract(client, poolAddress);

  const owner = await poolContract.read.owner();

  console.log('accountAddress', accountAddress);
  console.log('owner', owner);

  return true;
}
